import React from 'react';

import { useContentRequirementsContext } from '../../features/RestrictNavigation/ContentRequirementsProvider';
import { useTrackingStatus } from '../../features/tracking/components/functional/useTrackingStatus';
import { useStudentSelector } from '../../store/selectors/useStudentSelector';
import { ProgressBarStepModel } from './model';
import { ProgressStepComponent } from './ProgressStepComponent';

interface AudioProgressStepProps extends ProgressBarStepModel {
  onClick?: () => void;
}

const getWidth = (currentTime: number, duration: number) => {
  return Math.round((currentTime / duration) * 100);
};

export const AudioProgressStep: React.FC<AudioProgressStepProps> = ({ id, selected, disabled, onClick }) => {
  const { isComplete } = useTrackingStatus(id);
  const audioData = useStudentSelector((studentStore) => studentStore.audioState.get(id));
  const { fulfilled, fulfillItemRequirements } = useContentRequirementsContext();

  const isCompleted = !disabled && isComplete;
  const isLoaded = Boolean(audioData?.duration);
  const hasAudioEnded = audioData?.hasEndedOnce ?? false;

  React.useEffect(() => {
    if (hasAudioEnded) {
      fulfillItemRequirements();
    }
  }, [hasAudioEnded, fulfillItemRequirements]);

  const inProgress: boolean = !isCompleted && selected && isLoaded;
  const width = audioData?.duration ? getWidth(audioData.currentTime, audioData.duration) : 0;

  return (
    <ProgressStepComponent
      id={id}
      onClick={onClick}
      disabled={disabled}
      selected={selected}
      style={
        !fulfilled
          ? {
              width: `${width}%`,
            }
          : undefined
      }
      inProgress={inProgress}
    />
  );
};
